import { DayModel } from "../../../models/OvertimeSchedule";
import { OvertimeProyEjecValues } from "./OvertimeProyEjecValues";

interface Props {
  day?: DayModel;
  compact?: boolean;
}

export const DayOvertimeValueCell = ({ day, compact }: Props) => {
  if (!day) {
    return <OvertimeProyEjecValues empty compact={compact} />;
  }

  return (
    <OvertimeProyEjecValues
      scheduled={day.scheduledOvertime}
      worked={day.workedOvertime}
      isExceeded={day.dailyAllowedOvertimeExceeded}
      compact={compact}
    />
  );
};
